module.exports = __webpack_public_path__ + "static/media/Resources.b93d5b36.png";